<template>
  <div class="pt-3 pl-1 pr-1">
    <div class="card card-sticky" style="border: none">
      <div class="card-body p-2 vacancy-wrap">
        <h4 class="card-title p-2">{{ $t("selectedVakant") }}</h4>
        <p class="card-title-desc"></p>
        <div role="tablist">
          <VacancyCard
            v-for="(item, index) in list"
            :key="index + 's'"
            :item="item"
            :collapseItems="collapseItems"
            @show="show"
            @returnDoc="returnDoc"
            @startTest="
              (e) => {
                $emit('startTest', e);
              }
            "
          >
          </VacancyCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeService from "@/services/employee.service";
import { mapState } from "vuex";
import VacancyCard from "@/components/VacancyCard";
export default {
  computed: {
    ...mapState("employee", ["employee", "passportDate"]),
  },
  data() {
    return {
      list: [],
      visible: false,
      collapseItems: [],
      key: null,
      loading: false,
    };
  },
  components: {
    VacancyCard,
  },
  async created() {
    await this.getList();
  },
  methods: {
    show(item) {
      EmployeeService.getStatusHistory(this.employee.id, item.staffListVacancyId).then(
        (res) => {
          this.$nextTick(() => {
            this.collapseItems = res.data;
          });
        }
      );
    },
    getList() {
      EmployeeService.getSelectedVakants().then((rs) => {
        this.$nextTick(() => {
          this.list = rs.data;
        });
      });
    },
    async returnDoc(item) {
      this.$bvModal
        .msgBoxConfirm(this.$t("returnDoc"), {
          title: this.$t("returnDocument"),
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("actions.yes"),
          cancelTitle: this.$t("actions.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            await EmployeeService.returnDocument(item.id);
            this.loading = false;
            this.getList();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
};
</script>

<style lang="scss">
.card-sticky {
  @media (min-width: 1200px) {
    position: sticky !important;
    top: 10px;
  }
}
.vacancy-wrap {
  @media (min-width: 1200px) {
    height: calc(100vh);
    overflow-y: scroll;
    padding-bottom: 200px !important;
  }
  /* width */
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #a5adbc;
    border-radius: 16px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #9cb6ce;
  }
}
//
.verti-timeline {
  border-left: 3px dashed grey;
  margin: 0 10px;
  .event-list {
    position: relative;
    padding: 0px 0px 40px 30px;

    .event-timeline-dot {
      position: absolute;
      left: -9px;
      top: 0px;
      z-index: 9;
      font-size: 16px;
    }
    .event-content {
      position: relative;
      border: 2px solid grey;
      border-radius: 7px;
    }

    &.active {
      .event-timeline-dot {
        color: blue;
      }
    }

    &:last-child {
      padding-bottom: 0px;
    }
  }
}

/************** Horizontal timeline **************/

.hori-timeline {
  .events {
    .event-list {
      text-align: center;
      display: block;

      .event-down-icon {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: 100%;
          top: 16px;
          left: 0;
          right: 0;
          border-bottom: 3px dashed 3000;
        }
        .down-arrow-icon {
          position: relative;
          background-color: white;
          padding: 4px;
        }
      }

      &:hover {
        .down-arrow-icon {
          animation: fade-down 1.5s infinite linear;
        }
      }

      &.active {
        .down-arrow-icon {
          animation: fade-down 1.5s infinite linear;
          &:before {
            content: "\ec4c";
          }
        }
      }
    }
  }
}
</style>
